/**
 * Wholesale Signup Notification
 * Shows a notification when user comes from signup page with from=signup parameter
 */

// Check if current page is wholesale collection
function isWholesalePage() {
  return window.location.pathname.includes('/collections/wholesale');
}

// Create notification element
function createNotificationElement() {
  // Get section settings if available
  const sectionElement = document.querySelector('.wholesale-signup-notification-section');
  const title = sectionElement?.getAttribute('data-notification-title') || 'Application Under Review';
  const message =
    sectionElement?.getAttribute('data-notification-message') ||
    'Thank you for your wholesale application! Please check your email for a confirmation message. Our team will review your application and contact you within 2-3 business days.';
  const autoHideDelay = parseInt(sectionElement?.getAttribute('data-auto-hide-delay')) || 10;

  // Create overlay container
  const overlay = document.createElement('div');
  overlay.className = 'wholesale-notification-overlay';

  // Create notification modal
  const notification = document.createElement('div');
  notification.className = 'wholesale-notification';
  notification.innerHTML = `
    <div class="wholesale-notification__content">
      <div class="wholesale-notification__text">
        <h3>${title}</h3>
        <p>${message}</p>
      </div>
    </div>
    <button class="wholesale-notification__close" aria-label="Close notification">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3.06956 3.06906C3.36232 2.77632 3.83719 2.77659 4.13011 3.06906L9.67913 8.61808C9.75723 8.69618 9.88385 8.69619 9.96196 8.6181L15.511 3.07004L15.5686 3.01828C15.8632 2.77813 16.297 2.79549 16.5715 3.07004C16.8642 3.36295 16.8643 3.83776 16.5715 4.13059L11.0225 9.67862C10.9444 9.75672 10.9444 9.88336 11.0225 9.96147L16.4934 15.4323L16.5451 15.489C16.7852 15.7836 16.7679 16.2184 16.4934 16.4929C16.2189 16.7674 15.7841 16.7847 15.4895 16.5446L15.4328 16.4929L9.96197 11.022C9.88386 10.9439 9.75722 10.9439 9.67911 11.022L4.20921 16.4929C3.91638 16.7857 3.44157 16.7856 3.14866 16.4929C2.85577 16.2 2.85577 15.7252 3.14866 15.4323L8.61859 9.96146C8.69669 9.88335 8.69668 9.75673 8.61858 9.67863L3.06956 4.12961C2.77708 3.83668 2.77681 3.36182 3.06956 3.06906Z" fill="#1D1E21"/>
      </svg>
    </button>
  `;

  // Add notification to overlay
  overlay.appendChild(notification);

  // Add event listeners
  const closeBtn = notification.querySelector('.wholesale-notification__close');
  closeBtn.addEventListener('click', () => {
    hideNotification(overlay);
  });

  // Close on overlay click
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      hideNotification(overlay);
    }
  });

  // Auto hide after specified delay
  // setTimeout(() => {
  //   hideNotification(overlay);
  // }, autoHideDelay * 1000);

  return overlay;
}

// Hide notification with animation
function hideNotification(overlay) {
  const notification = overlay.querySelector('.wholesale-notification');

  // Hide overlay and notification
  overlay.classList.remove('wholesale-notification-overlay--visible');
  notification.classList.remove('wholesale-notification--visible');

  setTimeout(() => {
    if (overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }, 300);
}

// Show notification
function showNotification() {
  const overlay = createNotificationElement();

  // Add to page
  document.body.appendChild(overlay);

  // Show with animation
  setTimeout(() => {
    overlay.classList.add('wholesale-notification-overlay--visible');
    const notification = overlay.querySelector('.wholesale-notification');
    notification.classList.add('wholesale-notification--visible');
  }, 100);
}

// Initialize notification system
function initWholesaleSignupNotification() {
  // Check if we're on the wholesale collection page
  if (!isWholesalePage()) {
    return;
  }

  // Check for from=signup parameter
  const urlParams = new URLSearchParams(window.location.search);
  const fromSignup = urlParams.get('from');

  if (fromSignup === 'signup') {
    showNotification();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initWholesaleSignupNotification);
